import axiosConfig from "./axiosConfig";

export interface ImportSoracomSimRequest {
  imsi: string;
}

export interface ImportSoracomSimResponse {
  site: Record<string, unknown>;
  subscriber: Record<string, unknown>;
}

const postImportSoracomSim = async (
  authToken: string,
  siteId: string,
  esysUuid: string,
  request: ImportSoracomSimRequest
): Promise<ImportSoracomSimResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/ingestion/soracom/import_sim`,
    request,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: { esysUuid },
    }
  );
  return data;
};

export default postImportSoracomSim;
